(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-app"] && !Shopify.designMode) return;
  try {
    
class QuizApp {
  constructor(container) {
    console.log('QuizApp constructor called');
    if (!container) {
      console.log('No container found');
      return;
    }
    this.container = container;
    this.modal = container.querySelector('[data-quiz-modal]');
    if (!this.modal) {
      console.log('No modal found');
      return;
    }
    
    console.log('Initializing QuizApp');
    this.initializeElements();
    this.bindEvents();
    this.selectedAnswers = new Set();
    
    console.log('Current hash:', window.location.hash);
    this.handleURLParams();
  }

  handleURLParams() {
    console.log('handleURLParams called, current hash:', window.location.hash);
    if (window.location.hash === '#quiz-modal') {
      console.log('Hash matches #quiz-modal, showing quiz');
      this.showQuiz();
    }

    window.addEventListener('hashchange', () => {
      console.log('Hash changed to:', window.location.hash);
      if (window.location.hash === '#quiz-modal') {
        console.log('Hash changed to #quiz-modal, showing quiz');
        this.showQuiz();
      }
    });
  }

  showQuiz() {
    console.log('showQuiz called');
    this.container.style.display = 'block';
    this.openModal();
    this.showPage('quiz');
  }

  initializeElements() {
    this.enterButton = this.container.querySelector('.quiz-enter-button');
    this.submitButton = this.container.querySelector('.quiz-submit');
    this.retryButtons = this.container.querySelectorAll('.quiz-retry');
    this.overlay = this.modal.querySelector('.quiz-modal__overlay');
    this.closeButton = this.modal.querySelector('.quiz-modal__close');
    this.errorMessage = this.container.querySelector('.quiz-error');
    this.answerButtons = this.container.querySelectorAll('.quiz-answer-button');
    this.modalContent = this.modal.querySelector('.quiz-modal__content');
    
    this.resultPages = {
      result1: this.container.querySelector('[data-quiz-page="result-1"]'),
      result2: this.container.querySelector('[data-quiz-page="result-2"]')
    };
  }

  debugFormData() {
    const form = this.modalContent.querySelector('form[action="/cart/add"]');
    if (form) {
      console.log('Form found:', form);
      console.log('Form inputs:', form.querySelectorAll('input, select'));
      const formData = new FormData(form);
      console.log('Form data:', Object.fromEntries(formData));
    } else {
      console.log('No form found in modal content');
    }
  }

  loadProductContent(opener) {
    fetch(opener.getAttribute('data-product-url'))
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
        
        if (!this.productElement) {
          console.error('Product section not found');
          return;
        }

        this.preventDuplicatedIDs();
        this.removeDOMElements();
        
        // Set the innerHTML
        this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

        // Initialize any variant selectors if they exist
        const variantSelectors = this.modalContent.querySelectorAll('select[name="id"], input[name="id"]');
        if (variantSelectors.length > 0) {
          // Make sure the first variant is selected
          variantSelectors[0].dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Debug form data
        this.debugFormData();
      })
      .catch(error => {
        console.error('Error loading product:', error);
      });
  }

  bindEvents() {
    if (this.enterButton) {
      this.enterButton.addEventListener('click', () => {
        this.openModal();
        this.showPage('quiz');
      });
    }

    if (this.submitButton) {
      this.submitButton.addEventListener('click', () => {
        this.handleSubmit();
      });
    }

    this.retryButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.showPage('quiz');
        this.resetQuiz();
      });
    });

    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => {
        this.closeModal();
      });
    }

    if (this.modal) {
      this.modal.addEventListener('click', (event) => {
        if (event.target === this.modal || event.target === this.overlay) {
          this.closeModal();
        }
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.style.display === 'block') {
        this.closeModal();
      }
    });

    this.answerButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.toggleAnswer(button);
      });
    });

    this.handleAddToCartEvents();
  }

  toggleAnswer(button) {
    const answerText = button.dataset.answer;
    
    if (this.selectedAnswers.has(answerText)) {
      this.selectedAnswers.delete(answerText);
      button.classList.remove('selected');
    } else {
      this.selectedAnswers.add(answerText);
      button.classList.add('selected');
    }
    
    if (this.errorMessage) {
      this.errorMessage.style.display = 'none';
    }
  }

handleAddToCartEvents() {
    this.modal.addEventListener('submit', async (e) => {
      const form = e.target.closest('form[action="/cart/add"]');
      if (form) {
        e.preventDefault();
        
        const submitButton = form.querySelector('button[type="submit"]');
        
        const formInputs = form.querySelectorAll('input, select');
        const formData = {};
        
        formInputs.forEach(input => {
          formData[input.name] = input.value;
        });

        if (!formData.id) {
          console.error('No variant ID found in form');
          return;
        }

        try {
          if (submitButton) {
            submitButton.classList.add('loading');
            submitButton.disabled = true;
          }

          // First add to cart
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: [{
                id: formData.id,
                quantity: parseInt(formData.quantity || 1, 10),
                properties: formData.properties || {}
              }]
            })
          });

          if (!response.ok) {
            throw new Error('Cart addition failed');
          }

          const responseData = await response.json();

          // Fetch sections in the format the cart notification expects
          const sections = 'cart-notification-product,cart-notification-button,cart-icon-bubble';
          const sectionsUrl = `${window.location.pathname}?sections=${sections}`;
          
          const sectionsResponse = await fetch(sectionsUrl);
          const sectionsData = await sectionsResponse.json();

          // Get the cart notification element
          const cartNotification = document.querySelector('cart-notification');
          if (cartNotification) {
            // Prepare the data object that the cart notification component expects
            const cartData = {
              key: responseData.items[0].key,
              sections: sectionsData
            };
            
            // Render the cart notification
            cartNotification.renderContents(cartData);
          }

          // Close modal after successful addition
          setTimeout(() => this.closeModal(), 1000);

        } catch (error) {
          console.error('Error adding to cart:', error);
          alert('Unable to add item to cart. Please try again.');
        } finally {
          if (submitButton) {
            submitButton.classList.remove('loading');
            submitButton.disabled = false;
          }
        }
      }
    });

    // Also handle click events on add to cart buttons
    this.modal.addEventListener('click', async (e) => {
      const addToCartButton = e.target.closest('button[type="submit"], .add-to-cart-button, .product-form__submit');
      if (addToCartButton) {
        const form = addToCartButton.closest('form[action="/cart/add"]');
        if (form) {
          e.preventDefault();
          form.dispatchEvent(new Event('submit', { bubbles: true }));
        }
      }
    });
  }

  openModal() {
    console.log('openModal called');
    if (this.modal) {
      this.modal.style.display = 'block';
      document.body.style.overflow = 'hidden';
    }
  }

  closeModal() {
    if (this.modal) {
      this.modal.style.display = 'none';
      this.container.style.display = 'none';
      document.body.style.overflow = '';
      this.resetQuiz();
      if (window.location.hash === '#quiz-modal') {
        window.location.hash = '';
      }
    }
  }

  showPage(page) {
    const pages = this.container.querySelectorAll('[data-quiz-page]');
    pages.forEach(el => {
      el.style.display = 'none';
    });
    
    const targetPage = this.container.querySelector(`[data-quiz-page="${page}"]`);
    if (targetPage) {
      targetPage.style.display = 'block';
      this.modalContent.scrollTop = 0;
    }
  }
  
  handleSubmit() {
    if (this.selectedAnswers.size === 0) {
      if (this.errorMessage) {
        this.errorMessage.style.display = 'block';
      }
      return;
    }

    const hasProduct1Answer = Array.from(this.answerButtons)
      .some(button => 
        button.classList.contains('selected') && 
        button.hasAttribute('data-product-1')
      );

    this.showPage(hasProduct1Answer ? 'result-1' : 'result-2');
  }

  resetQuiz() {
    this.selectedAnswers.clear();
    this.answerButtons.forEach(button => {
      button.classList.remove('selected');
    });
    
    if (this.errorMessage) {
      this.errorMessage.style.display = 'none';
    }
  }

  preventDuplicatedIDs() {
    if (this.productElement) {
      const elements = this.productElement.querySelectorAll('[id]');
      elements.forEach(element => {
        const oldID = element.id;
        const newID = `quickview-${oldID}`;
        element.id = newID;
        
        // Update any associated labels
        const labels = this.productElement.querySelectorAll(`label[for="${oldID}"]`);
        labels.forEach(label => {
          label.setAttribute('for', newID);
        });
      });
    }
  }

  removeDOMElements() {
    if (this.productElement) {
      // Remove any elements that shouldn't be in the quickview
      const elementsToRemove = this.productElement.querySelectorAll('.product__media-list, .product__xr-button');
      elementsToRemove.forEach(element => element.remove());
    }
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;
    
    // Execute any scripts in the new content
    const scripts = element.getElementsByTagName('script');
    Array.from(scripts).forEach(script => {
      const newScript = document.createElement('script');
      Array.from(script.attributes).forEach(attr => {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.appendChild(document.createTextNode(script.innerHTML));
      script.parentNode.replaceChild(newScript, script);
    });
  }
}

// Immediately invoke initialization function
(function initQuizApp() {
  console.log('Initializing QuizApp - script loaded');
  
  function init() {
    console.log('Init function called');
    const quizContainer = document.querySelector('[data-section-type="quiz-app"]');
    console.log('Quiz container found:', !!quizContainer);
    
    if (quizContainer) {
      new QuizApp(quizContainer);
    }
  }

  // Handle both immediate and DOMContentLoaded scenarios
  if (document.readyState === 'loading') {
    console.log('Document still loading, adding DOMContentLoaded listener');
    document.addEventListener('DOMContentLoaded', init);
  } else {
    console.log('Document already loaded, initializing immediately');
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
